import { apiSlice } from "../apiSlice";

export const capitalApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addCapital: builder.mutation({
      query: (data) => ({
        url: "/capital-intake/add-capital",
        method: "POST",
        body: data,
      }),
      invalidatesTags: () => [
        { type: "capital-intake" },
        { type: "currentCapital" }, // Invalidate the customer list (only if required)
      ],
    }),
    getCapitalIntakes: builder.query({
      query: ({
        page,
        size,
        amount,
        createdBy,
        contributedBy,
        paymentMethod,
        from,
        to,
      }) =>
        `/capital-intake?pageNo=${page}&pageSize=${size}&amount=${amount}&createdBy=${createdBy}&contributedBy=${contributedBy}&paymentMethod=${paymentMethod}&from=${from}&to=${to}`,
      keepUnusedDataFor: 600,
      providesTags: (result) => {
        if (result?.content && Array.isArray(result.content)) {
          return [
            { type: "capital-intake" }, // provides tag for capital-intake
          ];
        }
        return [{ type: "capital-intake" }]; // fallback in case content is not available
      },
    }),
  }),
});

export const { useAddCapitalMutation, useGetCapitalIntakesQuery } = capitalApi;
